import { createSelector, Selector } from '@ngrx/store';

import { IdentityState } from './identity.state';

export const selectIdentityAccount = (identitySelector: Selector<object, IdentityState>) =>
  createSelector(identitySelector, (state: IdentityState) => state.account);
